const appearance = "(appearance: none) or (-webkit-appearance: none) or (-moz-appearance: none)";

export { appearance };
